import { render, staticRenderFns } from "./addPayments.vue?vue&type=template&id=13e9efc8&scoped=true&"
import script from "./addPayments.vue?vue&type=script&lang=js&"
export * from "./addPayments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e9efc8",
  null
  
)

export default component.exports